import React from 'react';
import ReactDOM from 'react-dom/client';
import theme from "./theme"
import { ThemeProvider } from "@mui/material/styles";
import App from './App';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<ThemeProvider theme={theme}> {/* Temayı tüm uygulamaya sağlıyoruz */}
    <App />
  </ThemeProvider>,

);
